<template>
    <div class="tileconf-container">
        <div class="switches-title switches-title-level1">
            <div class="circle-number">1</div>
            {{ $t('genral_cos_please_config_switch') }}
        </div>
        <div class="switches">
            <div class="switch-item" v-for="(v, k) in siteMenuList" :key="k">
                <div class="label">{{ $t(v.menuCode) }}</div>
                <div class="switch">
                    <el-switch
                            v-model="v.checked"
                            size="mini"
                            :disabled="v.disable"
                            @change="onSiteMenuListSwitchChange(v)"></el-switch>
                    <guidance-tooltip v-if="v.menuCode === 'client007'" :content="$t('groupReportingTip')" backgroundColor="none">
                        <i slot="icon" class="el-icon-warning" style="color:#fd349c;"></i>
                    </guidance-tooltip>
                </div>
            </div>
        </div>

        <div class="dashed-divide"></div>

        <div class="switches-title switches-title-level1">
            <div class="circle-number">2</div>
            {{ $t('genral_cos_please_config_tiles') }}
        </div>
        <el-collapse class="collapse">
            <el-collapse-item name="1" v-show="pbcOn">
                <div class="blue-border-title disable_select" slot="title">
                    {{ $t('config_pbc_tile') }}
                </div>
                <div class="collapse-container">
                    <div class="switches-title">
                        {{ $t('general_tiles_interim_audit_switch') }}
                    </div>
                    <div class="switch">
                        <el-switch v-model="hasInterim" size="mini" :active-text="$t('COMMON_YES')" :inactive-text="$t('COMMON_NO')" @change="onHasInterimChange"></el-switch>
                    </div>
                </div>
            </el-collapse-item>
            <el-collapse-item name="8" v-show="vatOn">
                <div class="blue-border-title disable_select" slot="title">
                    {{ $t('client008') }}
                </div>
                <div class="collapse-container">
                    <div class="switches-title">
                        {{ $t('general_tiles_vat_audit_switch') }}
                    </div>
                    <div class="switch">
                        <el-switch v-model="showVatInformation" size="mini" :active-text="$t('COMMON_YES')" :inactive-text="$t('COMMON_NO')" @change="onHasVatChange"></el-switch>
                    </div>
                </div>
            </el-collapse-item>
            <!--<el-collapse-item name="6" v-show="exchangeOn">
                <div class="blue-border-title disable_select" slot="title">
                    {{ $t('config_exchange_title') }}
                </div>
                <div class="collapse-container">
                    <div class="switches-title">
                        {{ $t('enable_ITU') }}
                    </div>
                    <div class="switch">
                        <el-switch
                            size="mini"
                            :active-text="$t('COMMON_YES')"
                            :inactive-text="$t('COMMON_NO')"
                            :active-value="1"
                            :inactive-value="0"
                            v-model="ituFlag"
                            @change="onRoleItuChange"
                        ></el-switch>
                    </div>
                </div>
            </el-collapse-item>-->
            <el-collapse-item name="3" v-show="SASOn">
                <div class="blue-border-title disable_select" slot="title">
                    {{ $t('config_Statutory_milestone') }}
                </div>
                <div class="collapse-container collapse-container-3">
                    <div class="milestone-title-tip">
                        <i class="el-icon-warning"></i>
                        {{ $t('milestone_title_tip') }}
                    </div>
                    <el-tabs
                        type="card"
                        v-model="milestone.activeTab"
                        addable
                        class="milestone-tabs"
                        :before-leave="beforeMilestoneTabLeave">
                        <el-tab-pane
                            v-for="(v, k) in milestone.list"
                            :key="k"
                            :name="`${k}`">
                            <template #label>
                                <div class="tab-label">
                                    <div class="tab-label-text">{{ v.milestoneName }}</div>
                                    <el-dropdown class="tab-label-dropdown" @command="(e) => onLevelMilestoneDropClick(e, v, k)">
                                        <span class="el-dropdown-link">
                                            <i class="el-icon-more"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="left" :disabled="(v.editable === '0' || (k > 0 && milestone.list[k - 1].childMilestoneBO.some(val => val.editable === '0')))"> <i class="el-icon-back"></i> {{ $t('move_left') }}</el-dropdown-item>
                                            <el-dropdown-item command="right" :disabled="v.editable === '0'"> <i class="el-icon-right"></i> {{ $t('move_right') }}</el-dropdown-item>
                                            <el-dropdown-item command="rename" :disabled="v.editable === '0'"> <i class="el-icon-edit"></i> {{ $t('rename') }}</el-dropdown-item>
                                            <el-dropdown-item command="delete" :disabled="v.editable === '0'"> <span :style="{color: v.editable === '0' ? '#bbbbbb' : 'red'}"><i class="el-icon-delete"></i> {{ $t('COMMON_DELETE') }}</span> </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </template>
                            <el-table :data="v.childMilestoneBO" class="milestone-table" border stripe>
                                <el-table-column :label="$t('table_column_lable_milestone')" align="center">
                                    <template slot-scope="scope">
                                        <el-form :model="scope.row" :rules="milestoneFormRule" :ref="`${scope.row.id}_milestoneName`">
                                            <el-form-item prop="milestoneName">
                                                <el-input size="mini" v-model="scope.row.milestoneName" @change="onMilestoneNameChange" :disabled="scope.row.editable === '0'"></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('table_column_lable_deadline')" align="center" width="200">
                                    <template slot-scope="scope">
                                        <el-switch
                                            size="mini"
                                            v-model="scope.row.targetTimeSelected"
                                            :active-value="1"
                                            :inactive-value="0"
                                            @change="onTargetTimeChange"
                                            :disabled="scope.row.editable === '0'"
                                            inactive-color="#a9acaf"
                                        ></el-switch>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('table_column_lable_remarks')" align="center" width="200">
                                    <template slot-scope="scope">
                                        <el-input size="mini" v-model="scope.row.remark" @change="onRemarkChange" :disabled="scope.row.editable === '0'"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('table_column_lable_client_show')" align="center" width="200">
                                    <template slot-scope="scope">
                                        <el-switch
                                            size="mini"
                                            v-model="scope.row.accessFlag"
                                            :active-value="1"
                                            :inactive-value="0"
                                            @change="onAccessFlagChange"
                                            :disabled="scope.row.editable === '0'"
                                            inactive-color="#a9acaf"
                                        ></el-switch>
                                    </template></el-table-column>
                                <el-table-column :label="$t('table_column_lable_action')" width="170" align="center">
                                    <template slot-scope="{ row, $index }">
                                        <div class="table-actions">
                                            <div class="table-action">
                                                <i style="margin-left: 10px"
                                                @click="milestoneUp($index, k, row)"
                                                :class="['el-icon-top', $index == 0 || row.editable === '0' || milestone.list[k].childMilestoneBO[$index - 1].editable === '0' ? 'table-action-disable' : '']"></i>
                                            </div>
                                            <div class="table-action">
                                                <i style="margin-left: 10px"
                                                @click="milestoneDown($index, k, row)"
                                                :class="['el-icon-bottom', $index == v.childMilestoneBO.length - 1 || row.editable === '0' ? 'table-action-disable' : '']"></i>
                                            </div>
                                            <div class="table-action">
                                                <i style="margin-left: 10px"
                                                @click="milestoneDel(v.id, row.id, row)"
                                                :class="['el-icon-delete', 'wl-icon-delete', row.editable === '0' ? 'table-action-disable' : '']"></i>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane name="milestone-add" :closable="false">
                            <span slot="label" @click="onAddLevel1MilestoneClick"><i class="el-icon-plus"></i> {{ $t('btn_add') }}</span>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="add-milestone-btn">
                        <el-button class="wl-green" size="mini" @click="onAddMilestoneClick">
                            <i class="el-icon-plus"></i>
                            {{ $t('add_milestone') }}
                        </el-button>
                    </div>
                    <el-dialog :visible.sync="milestone.deleteConfirm.show" width="300px">
                        <template #title>
                            {{ $t('dialog_title_warning') }}
                        </template>
                        <template>
                            <div class="delete-confirm-container">
                                <div class="delete-confirm-body">
                                    <i class="el-icon-warning" style="color: #ee7200;"></i>
                                    <div>{{ $t('confirm_delete_milestone') }}</div>
                                </div>
                                <div class="delete-confirm-footer">
                                    <el-button @click="deleteConfirmCancel">{{ $t('btn_cancel') }}</el-button>
                                    <el-button class="wl-green" @click="deleteConfirmConfirm">{{ $t('btn_confirm') }}</el-button>
                                </div>
                            </div>
                        </template>
                    </el-dialog>
                    <el-dialog :visible.sync="milestone.add.show">
                        <template #title>
                            {{ milestone.add.index > -1 ? $t('rename_milestone') : $t('add_milestone') }}
                        </template>
                        <template>
                            <div class="delete-confirm-container">
                                <el-form :model="milestone.add" style="width: 100%" :rules="milestoneFormRule" ref="level1MilestoneAdd">
                                    <el-form-item class="delete-confirm-body" prop="value" :label="$t('please_input_milestone_name')">
                                        <el-input size="mini" v-model="milestone.add.value"></el-input>
                                    </el-form-item>
                                    <div class="delete-confirm-footer">
                                        <el-button @click="addMilestoneCancel">{{ $t('btn_cancel') }}</el-button>
                                        <el-button class="wl-green" @click="commitAddMilestone">{{ $t('btn_confirm') }}</el-button>
                                    </div>
                                </el-form>
                            </div>
                        </template>
                    </el-dialog>
                </div>
            </el-collapse-item>
            <el-collapse-item name="5" v-show="confirmationOn">
                <div class="blue-border-title disable_select" slot="title">
                    {{ $t('general_tile_confirmation') }}
                </div>
                <div class="collapse-container">
                    <div class="switches-title">
                        {{ $t('if_show_confirmation_reply_status') }}
                    </div>
                    <div class="switch">
                        <el-switch v-model="showConfirmationReply" size="mini" :active-text="$t('COMMON_YES')" :inactive-text="$t('COMMON_NO')" @change="onConfirmationReplyChange"></el-switch>
                    </div>
                </div>
            </el-collapse-item>
            <el-collapse-item name="2" v-show="groupAuditOn">
                <div class="blue-border-title disable_select" slot="title">
                    {{ $t('config_group_audit_title') }}
                </div>
                <div class="collapse-container">
                    <!-- <div class="switches-title">
                        {{ $t('EXCHANGE_TAB_CONTROL') }}
                    </div>
                     <div class="switch">
                        <el-switch
                            v-model="asGroupAuditor"
                            size="mini"
                            :active-text="$t('COMMON_YES')"
                            :inactive-text="$t('COMMON_NO')"
                            :active-value="1"
                            :inactive-value="0"
                            @change="onAsGroupAuditorChange"
                        ></el-switch>
                    </div> -->
                    <div class="switches-title">
                        {{ $t('allow_component_down_upload') }}
                    </div>
                    <div class="switch">
                        <el-switch
                                size="mini"
                                :active-text="$t('COMMON_YES')"
                                :inactive-text="$t('COMMON_NO')"
                                :active-value="1"
                                :inactive-value="0"
                                v-model="componentDownload"
                                @change="onComponentDownloadChange"
                        ></el-switch>
                    </div>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import { UserInput, loading } from '@/utils'
import GuidanceTooltip from "@/components/common/GuidanceTooltip";

export default {
    name: 'TileConfiguration',
    components: {GuidanceTooltip},
    mounted() {
        // this.hereSiteMenuList = this.siteMenuList
        this.getSiteTiles()
    },
    data() {return {
        // hereSiteMenuList: []
        clientName: '',
        interimChecked: true,
        exchangeChecked: true,
        siteMenuList: [],
        hasInterim: false,  // 中期审计 开关
        showVatInformation: false, //增值税信息
        asGroupAuditor: 0, // 本集团是审计项目小组
        componentDownload: 0,   // 是否允许组成用户...
        showConfirmationReply: false, // 是否展示函证回函状态
        ituFlag: 1, // 是否开启 ITU
        milestone: {
            list: [],
            activeTab: '',
            deleteConfirm: {
                show: false,
                level: 0,
                id: ''
            },
            add: {
                show: false,
                value: '',
                index: -1        // index > -1 则改名
            }
        },
        insight: {
            list: [],
            upload: {
                currIndex: 0
            }
        },
        milestoneFormRule: {
            milestoneName: [
                { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                {
                    pattern: UserInput.reg3,
                    trigger: 'blur',
                    message: this.$t('ILLEGAL_USER_INPUT_04')
                }
            ],
            value: [
                { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                {
                    pattern: UserInput.reg3,
                    trigger: 'blur',
                    message: this.$t('ILLEGAL_USER_INPUT_04')
                }
            ]
        }
    }},
    methods: {
        onInsightTitleChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onInsightTitleChange',
                value: this.insight.list
            })
        },
        onInsightUrlChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onInsightUrlChange',
                value: this.insight.list
            })
        },
        onInsightImageChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onInsightFileChange',
                value: this.insight.list
            })
        },
        onMilestoneNameChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onMilestoneNameChange',
                value: this.milestone.list
            })
        },
        onTargetTimeChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onTargetTimeChange',
                value: this.milestone.list
            })
        },
        onRemarkChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onRemarkChange',
                value: this.milestone.list
            })
        },
        onAccessFlagChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onAccessFlagChange',
                value: this.milestone.list
            })
        },
        onHasInterimChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onHasInterimChange',
                value: this.hasInterim
            })
        },
        onHasVatChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onHasVatChange',
                value: this.showVatInformation
            })
        },
        onConfirmationReplyChange() {
            localStorage.setItem('showConfirmationReplyChanged', 1)
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onConfirmationReplyChange',
                value: this.showConfirmationReply
            })
        },
        onAsGroupAuditorChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onAsGroupAuditorChange',
                value: this.asGroupAuditor
            })
            this.componentDownload = 0
        },
        onComponentDownloadChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onComponentDownloadChange',
                value: this.componentDownload
            })
        },
        onRoleItuChange() {
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onRoleItuChange',
                value: this.ituFlag
            })
        },
        /**
         * 一级 milestone 下拉菜单被点击
         * @param {*} e     要处理的事件
         * @param {*} v     当前一级milestone
         * @param {*} k     当前一级milestone索引
         */
        onLevelMilestoneDropClick(e, v, k) {
            switch(e) {
                case 'left': {
                    const index = k
                    if(index === 0) return;
                    let temp = []
                    const list = this.milestone.list
                    if(index === 1) {
                        temp = [list[1], list[0], ...list.slice(2, list.length)]
                    } else {
                        temp = [...list.slice(0, index - 1), list[index], list[index - 1], ...list.slice(index + 1, list.length)]
                    }
                    this.milestone.list = temp

                    this.$emit('onConfChange', {
                        tab: 2,
                        key: 'onLevelMilestoneDropClick.left',
                        value: this.milestone.list
                    })
                } break
                case 'right': {
                        const list = this.milestone.list
                        const len = this.milestone.list.length
                        const index = k
                        let temp = []
                        if(len === 0 || index === len - 1) return
                        if(index === len - 2){
                          temp = [...list.slice(0, index), list[index + 1], list[index]]
                        } else {
                          temp = [...list.slice(0, index), list[index + 1], list[index], ...list.slice(index + 2, len)]
                        }
                        this.milestone.list = temp
                        this.$emit('onConfChange', {
                            tab: 2,
                            key: 'onLevelMilestoneDropClick.right',
                            value: this.milestone.list
                        })
                } break
                case 'rename': {
                    this.milestone.add = {
                        show: true,
                        value: v.milestoneName,
                        index: k
                    }
                } break
                case 'delete': {
                    this.milestone.deleteConfirm = {
                        show: true,
                        level: 1,
                        id: `${k}`
                    }
                } break
            }
        },
        /**
         * 点击 tab 上的添加触发
         * 显示输入框
         */
        onAddLevel1MilestoneClick() {
            this.milestone.add = {
                show: true,
                value: '',
                index: -1
            }
        },
        /**
         * 添加一级 milestone 取消
         */
        addMilestoneCancel() {
            this.milestone.add = {
                show: false,
                value: '',
                index: -1
            }
        },
        /**
         * 确认添加一级milestone
         */
        commitAddMilestone() {
            this.$refs['level1MilestoneAdd'].validate(valid => {
                if (valid) {
                    if (this.milestone.add.value.replace(/ /g, '') === '') {
                        this.$message.warning(this.$t('milestone_name_invalid'))
                        return
                    }
                    if (this.milestone.list.findIndex(v => v.milestoneName == this.milestone.add.value) !== -1) {
                        this.$message.warning(this.$t('First_LEVEL_MILESTONE_NAME_REPEAT'))
                        return
                    }
                    if (this.milestone.add.index > -1) {
                        this.milestone.list[this.milestone.add.index].milestoneName = this.milestone.add.value
                    } else {
                        this.milestone.list.push({
                            accessFlag: 0,
                            childMilestoneBO: [],
                            editable: "1",
                            id: '',
                            milestoneName: this.milestone.add.value,
                            parentId: null,
                            remark: '',
                            siteId: this.getSite.siteId,
                            sort: this.milestone.list && this.milestone.list.length ? this.milestone.list.length : 0,
                            targetTimeSelected: 0
                        })
                    }
                    this.$emit('onConfChange', {
                        tab: 2,
                        key: 'commitAddMilestone',
                        value: this.milestone.list
                    })
                    this.addMilestoneCancel()
                } else {
                    this.$message.warning(this.$t('milestone_name_invalid_special_char'))
                }
            })
        },
        /**
         * 点击添加洞察信息
         */
        onAddInsightClick() {
            this.insight.list.push({
                createDate: "",
                id: `RandLevel1_${Math.random(9999)}`,
                imageByte: "",
                imageName: "",
                insightImage: "",
                insightTitle: "",
                insightUrl: "",
                siteId: this.getSite.siteId,
                sort: this.insight.list.length
            })
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onAddInsightClick',
                value: this.milestone.list
            })
        },
        /**
         * 当前模块的 save，被父页面调用
         */
        async handleSave() {
            const milestoneArr = this.milestone.list.reduce((pre, cur) => {
                pre = [...pre, ...cur.childMilestoneBO]
                return pre
            }, [])

            // 二级里程碑不允许全空格
            if (milestoneArr.some(v => v.milestoneName.replace(/ /g, '') === '')) {
                this.$message.warning(this.$t('milestone_name_invalid'))
                return
            }

            // 依次使用 el-form 的表单校验来校验二级里程碑名字
            try {
                await Promise.all(milestoneArr.map(v => {
                    return new Promise((resolve, reject) => {
                        this.$refs[`${v.id}_milestoneName`][0].validate(valid => {
                            if (valid) {
                                resolve()
                            } else {
                                reject()
                            }
                        })
                    })
                }))

                if (this.milestone.list.some(v => {
                    return [...new Set(v.childMilestoneBO.map(vv => vv.milestoneName))].length != v.childMilestoneBO.length
                })) {
                    this.$message.warning(this.$t('SECOND_LEVEL_MILESTONE_NAME_REPEAT'))
                    return
                }
                if (this.milestone.list.some(v => !v.childMilestoneBO || v.childMilestoneBO.length == 0)) {
                    this.$message.warning(this.$t('none_of_level2_milestone'))
                    return
                }

                const siteData = {
                    siteId: this.getSite.siteId,
                    hasInterim: this.hasInterim,
                    showVatInformation: this.showVatInformation,
                    componentDownload: this.componentDownload,
                    asGroupAuditor: this.asGroupAuditor,
                    showConfirmationReplyStatus: this.showConfirmationReply,
                    insightList: this.insight.list.map((v, k) => {
                        if (v.id.indexOf('RandLevel1') != -1) {
                            v.id = ''
                        }
                        v.sort = k + 1
                        return v
                    }),
                    siteMenuList: this.siteMenuList,
                    milestoneList: this.milestone.list.map((v, k) => {
                        if (v.id.indexOf('RandLevel1') != -1) {
                            v.id = ''
                        }
                        v.sort = k + 1
                        v.accessFlag = v.childMilestoneBO.some(value => value.accessFlag) ? 1 : 0
                        v.childMilestoneBO = v.childMilestoneBO.map((vv, kk) => {
                            if (vv.id.indexOf('RandLevel2') != -1) {
                                vv.id = ''
                            }
                            vv.sort = kk + 1
                            return vv
                        })
                        return v
                    }),
                    ituFlag: this.ituFlag
                }
                return API.general.saveTiles(siteData).then(res => {
                if (res.code == '1') {
                    this.$store.commit('common/setSite', {...this.getSite, ...siteData})
                    let menuCodeList = []
                    menuCodeList = this.siteMenuList.filter(item => item.checked).map(item => item.menuCode)
                    this.$store.commit('common/setShowMenuCodeList', menuCodeList)

                    // 如果把集团审计改为开，则需要变更 session 中的 siteClassification
                    if (this.siteMenuList.find(v => v.menuCode == 'client007' && v.checked)) {
                        sessionStorage.setItem('siteClassification', 'GROUP')
                    }

                    this.$message.success(this.$t('msg_save_success'))
                } else {
                    this.$message.error(this.$t(res.code))
                }
                }).catch(e => {
                    console.error(e);
                    this.$message.error(this.$t('SYS_USER_003'))
                }).finally(() => {})
            } catch (e) {
                console.error('保存时不合法：', e)
                this.$message.warning(this.$t('milestone_name_invalid_special_char'))
            }
        },
        /**
         * 当洞察信息的文件选框变动，上传文件
         */
        onInsightFileChange() {
            let fileParams = new FormData()
            fileParams.append('siteId', this.getSite.siteId)
            fileParams.append('file', this.$refs['insightUploadFileInput'].files[0])
            API.general.insightUploadFile(fileParams).then(res => {
                if (res.code == '1') {
                    this.insight.list[this.insight.upload.currIndex].insightImage = res.data
                    this.insight.list[this.insight.upload.currIndex].imageName = this.$refs['insightUploadFileInput'].files[0].name
                } else {
                    this.$message.error(this.$t(res.code))
                }

            }).catch(e => {
                console.error(e);
                this.$message.error(this.$t('file_upload_failed'))
            })
        },
        /**
         * 点击了洞察信息表格的文件输入框
         * 打开文件选择框
         *
         * @param {*} index 第 index 行被点了
         */
        onFileInputFocus(index) {
            this.insight.upload.currIndex = index
            document.getElementById('insightUploadFileInput').click()
        },
        /**
         * 洞察信息的测试 url
         * 直接用新页面打开
         *
         * @param {*} url
         */
        onInsightUrlTestClick(url) {
            window.open(url)
        },
        /**
         * 删除洞察信息
         * @param {*} index
         */
        deleInsights(index) {
            this.insight.list.splice(index, 1)
            this.$emit('onConfChange', {
                tab: 2,
                key: 'deleInsights',
                value: this.insight.list
            })
        },
        /**
         * 洞察信息排序上升
         */
        riseInsights(index) {
            if(index === 0) return;
            let temp = []
            const list = this.insight.list
            if(index === 1) {
                temp = [list[1], list[0], ...list.slice(2, list.length)]
            } else {
                temp = [...list.slice(0, index - 1), list[index], list[index - 1], ...list.slice(index + 1, list.length)]
            }
            this.insight.list = temp

            this.$emit('onConfChange', {
                tab: 2,
                key: 'riseInsights',
                value: this.insight.list
            })
        },
        /**
         * 洞察信息排序下降
         * @param {*} index
         */
        declineInsights(index) {
            const list = this.insight.list
            const len = this.insight.list.length
            let temp = []
            if(len === 0 || index === len - 1) return
            if(index === len - 2){
                temp = [...list.slice(0, index), list[index + 1], list[index]]
            } else {
                temp = [...list.slice(0, index), list[index + 1], list[index], ...list.slice(index + 2, len)]
            }
            this.insight.list = temp

            this.$emit('onConfChange', {
                tab: 2,
                key: 'declineInsights',
                value: this.insight.list
            })
        },
        /**
         * milestone 删除取消
         */
        deleteConfirmCancel() {
            this.milestone.deleteConfirm = {
                show: false,
                level: 0,
                id: ''
            }
        },
        /**
         * 确认删除一级/二级 milestone
         */
        deleteConfirmConfirm() {
            if (this.milestone.deleteConfirm.level == 1) {
                this.milestone.list.splice(this.milestone.deleteConfirm.id - 0, 1)
            }
            if (this.milestone.deleteConfirm.level == 2) {
                const ids = this.milestone.deleteConfirm.id.split('|')
                const find1 = this.milestone.list.findIndex(v => v.id === ids[0])
                if (find1 > -1) {
                    const find2 = this.milestone.list[find1].childMilestoneBO.findIndex(v => v.id == ids[1])
                    if (find2 > -1) {
                        this.milestone.list[find1].childMilestoneBO.splice(find2, 1)
                    }
                }
            }
            this.$emit('onConfChange', {
                tab: 2,
                key: 'deleteConfirmConfirm',
                value: this.milestone.list
            })
            this.deleteConfirmCancel()
        },
        /**
         * 添加二级 milestone
         */
        onAddMilestoneClick() {
            const currentActiveMilestone = this.milestone.list[this.milestone.activeTab]
            if (!currentActiveMilestone) return false
            this.milestone.list[this.milestone.activeTab].childMilestoneBO.push({
                accessFlag: false,
                childMilestoneBO: null,
                editable: "1",
                id: `RandLevel2_${Math.random(9999)}`,
                milestoneName: '',
                parentId: find.id,
                remark: '',
                siteId: this.getSite.siteId,
                sort: this.milestone.list[this.milestone.activeTab].childMilestoneBO.length,
                targetTimeSelected: false
            })

            this.$emit('onConfChange', {
                tab: 2,
                key: 'onAddMilestoneClick',
                value: this.siteMenuList
            })
        },
        /**
         * milestone 上升
         * @param {*} index 二级 milestone 索引
         * @param {*} k     一级 milestone 索引
         */
        milestoneUp(index, k, row) {
            if(index === 0) return;
            if (row.editable === '0') return
            if (this.milestone.list[k].childMilestoneBO[index - 1].editable === '0') return
            let temp = []
            const list = this.milestone.list[k].childMilestoneBO
            if(index === 1) {
              temp = [list[1], list[0], ...list.slice(2, list.length)]
            } else {
              temp = [...list.slice(0, index - 1), list[index], list[index - 1], ...list.slice(index + 1, list.length)]
            }
            this.milestone.list[k].childMilestoneBO = temp

            this.$emit('onConfChange', {
                tab: 2,
                key: 'milestoneUp',
                value: this.siteMenuList
            })
        },
        /**
         * milestone 下降
         * @param {*} index 二级 milestone 索引
         * @param {*} k     一级 milestone 索引
         */
        milestoneDown(index, k, row) {
            if (row.editable === '0') return

            const list = this.milestone.list[k].childMilestoneBO
            const len = this.milestone.list[k].childMilestoneBO.length
            let temp = []
            if(len === 0 || index === len - 1) return
            if(index === len - 2){
              temp = [...list.slice(0, index), list[index + 1], list[index]]
            } else {
              temp = [...list.slice(0, index), list[index + 1], list[index], ...list.slice(index + 2, len)]
            }
            this.milestone.list[k].childMilestoneBO = temp

            this.$emit('onConfChange', {
                tab: 2,
                key: 'milestoneDown',
                value: this.siteMenuList
            })
        },
        /**
         * 删除二级 milestone
         * @param {*} id1 一级的 id
         * @param {*} id2 二级的id
         */
        milestoneDel(id1, id2, row) {
            if (row.editable === '0') return
            this.milestone.deleteConfirm = {
                show: true,
                level: 2,
                id: `${id1}|${id2}`
            }
        },
        /**
         * milestone 切换 tab 之前
         * 如果要切换到添加 tab，则给拦住
         * @param {*} v
         */
        beforeMilestoneTabLeave(v) {
            if (v === 'milestone-add') return false
            return true
        },
        /**
         * 获取本页的设置
         */
        getSiteTiles() {
            const _loading = loading()
            _loading.load()
            API.general.siteTilesGeneral({siteId: this.getSite.siteId}).then(res => {
                if (res.code == '1') {
                    this.clientName = res.data.clientName
                    this.insight.list = res.data.insightList ? res.data.insightList.sort((a, b) => a.sort - b.sort) : []
                    this.milestone.list = res.data.milestoneList ? res.data.milestoneList.sort((a, b) => a.sort - b.sort).map(v => {
                        v.editable = v.childMilestoneBO.some(vv => vv.editable === '0') ? '0' : '1'
                        v.childMilestoneBO = v.childMilestoneBO.sort((a, b) => a.sort - b.sort)
                        return v
                    }) : []
                    if (res.data.milestoneList && res.data.milestoneList.length > 0) {
                        this.milestone.activeTab = '0'
                    }
                    this.siteMenuList = res.data.siteMenuList ? res.data.siteMenuList : []
                    this.siteMenuList.map(item => {
                        if(item.menuCode === 'client007' && item.checked) {
                            this.$set(item, 'disable', true)
                        }else {
                            this.$set(item, 'disable', false)
                        }
                    })
                    this.asGroupAuditor = res.data.asGroupAuditor
                    this.componentDownload = res.data.componentDownload
                    this.hasInterim = res.data.hasInterim
                    this.showVatInformation = res.data.showVatInformation
                    this.showConfirmationReply = res.data.showConfirmationReplyStatus
                    this.ituFlag = res.data.ituFlag ? 1 : 0
                } else {
                    this.$message({
                        type: 'error',
                        message: this.$t(res.code)
                    })
                }
            }).catch(e => {
                console.error(e);
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(e => {
                _loading.close()
            })
        },
        /**
         * 板块开关变动
         * @param {*} v
         */
        onSiteMenuListSwitchChange(v) {
             
            if (v.menuCode === 'client001' && !v.checked) {
                this.interimChecked = false
            }
            if (v.menuCode === 'client002' && !v.checked) {
                this.exchangeChecked = false
            }
            if (v.menuCode == 'client007' && v.checked) {
                this.$confirm(this.$t('groupReportingTip'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                }).then(() => {
                    
                }).catch(() => {
                    v.checked = false
                })
            }
            this.$emit('onConfChange', {
                tab: 2,
                key: 'onSiteMenuListSwitchChange',
                value: this.siteMenuList
            })
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
        }),
        confirmationOn() {
            return this.siteMenuList.filter(v => v.checked).map(v => v.menuCode).includes('client006')
        },
        pbcOn() {
            return this.siteMenuList.filter(v => v.checked).map(v => v.menuCode).includes('client001')
        },
        vatOn() {
            return this.siteMenuList.filter(v => v.checked).map(v => v.menuCode).includes('client008')
        },
        groupAuditOn() {
            return this.siteMenuList.filter(v => v.checked).map(v => v.menuCode).includes('client007')
        },
        SASOn() {
            return this.siteMenuList.filter(v => v.checked).map(v => v.menuCode).includes('client002')
        },
        insightsOn() {
            return this.siteMenuList.filter(v => v.checked).map(v => v.menuCode).includes('client004')
        },
        exchangeOn() {
            return this.siteMenuList.filter(v => v.checked).map(v => v.menuCode).includes('client005')
        },
        insightRules() {
            return {
                title: [
                    {required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'},
                    {
                        pattern: UserInput.reg,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_01')
                    }
                ],
                url: [{type: 'url', message: this.$t('FORM_VALIDATE_URL'), trigger: 'blur'}]
            }
        }
    },
    watch: {}
}
</script>
<style scoped>
.tileconf-container {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.switches-title {
    font-size: 12PX;
    margin: 20px 0 0px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.switches-title-level1 {
    color: #3879eb;
    font-size: 16px;
}
.switches-title-level1 .circle-number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #409eff;
    font-weight: 700;
    font-size: 14px;
    color: #409eff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
}
.switches-title .switch-title-tooltip-i {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #3879eb;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
}
.switches-title .switch-title-tooltip-i i {
    color: #e1ecff;
}
.switches {
    display: flex;
    flex-direction: row;
    margin: 10px 0 0px 20px;
    flex-wrap: wrap;
}
.switches .switch-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 30px 10px 0;
}
.switches .switch-item .label {
    font-weight: 600;
    font-size: 14PX;
}
.switches .switch-item .switch {
    margin-left: 10px;
}
.dashed-divide {
    width: calc(100% - 40px);
    margin: 30px 20px;
    border-top: dashed 1px #f2f2f3;
}
.blue-border-title {
    font-size: 14PX;
    font-weight: 600;
    padding-left: 20px;
    border-left: 5px solid #1e49e2;
    height: 24px;
    line-height: 24px;
}
.collapse {
    width: calc(100% - 40px);
    margin-left: 20px;
}
.collapse .switches-title {
    font-size: 14PX;
    margin: 0 0 0px 20px;
}

.collapse .switches-title-2 {
    margin-left: 100px;
}

.el-collapse {
    border-top: none !important;
}
.collapse-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}
.collapse-container .switch {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 30px;
}
.milestone-tabs {
    width: 100%;
}
.milestone-tabs .tab-label {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.milestone-tabs .tab-label .tab-label-text {
    font-size: 12px;
}
.milestone-tabs .tab-label .tab-label-dropdown {
    margin-left: 20px;
}
.milestone-table {
    width: 100%;
}

.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border-top: solid 2px #3879eb;
}
.el-tabs__item:last-of-type .el-icon-close {
    display: none;
}
.table-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: center;
    cursor: pointer;
}
.table-actions .table-action {
    color: #3879eb;
}
.table-actions .table-action-disable {
    color: #c4d8f9;
    cursor: not-allowed;
}
.table-actions .table-action:not(:last-child) {
    margin-right: 10px;
}
.table-actions .table-action i {
    font-size: 17px;
}
.collapse-container-3, .collapse-container-4 {
    flex-direction: column;
    align-items: flex-start;
}
.collapse-container-3 .milestone-title-tip {
    color:#fd349c;
    margin: 15px 10px;
}
.collapse-container-3 .milestone-title-tip .el-icon-warning {
    color:#fd349c;
}
.add-milestone-btn {
    margin: 10px 0 0 10px;
}
.delete-confirm-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.delete-confirm-container .delete-confirm-body {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.delete-confirm-container .delete-confirm-body div {
    margin-left: 10px;
}
.delete-confirm-container .delete-confirm-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-top: 20px;
}
.el-tabs__new-tab {
    display: none !important;
}
.insight-url-test {
    background-color: #f3f7ff;
    color: #3879eb;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.insight-url-test i {
    margin-left: 5px;
}
.add-insight-btn {
    margin: 10px 0 0 10px;
}
::v-deep .el-form-item{
    margin-bottom: 0 !important;
}
::v-deep .el-form-item__error {
    top: 30%;
    left: auto;
    right: 2%;
}
.tip-icon {
    margin-left: 20px;
}
</style>
